import { Card, Flex } from "antd";

import {
  CloseoutsBySubcontractor,
  InstallationsBySubcontractor,
  InstallationsRecap,
} from "projects/components";
import {
  IInstallationsRecap,
  IInstallationBySubcontractor,
  ICloseoutBySubcontractor,
} from "projects/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  installationsRecap?: IInstallationsRecap;
  installationsBySubcontractor?: IInstallationBySubcontractor[];
  closeoutsBySubcontractor?: ICloseoutBySubcontractor[];
};

export const OperationsManagerDashboardInstallationsCard = ({
  loading,
  installationsRecap,
  installationsBySubcontractor,
  closeoutsBySubcontractor,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='operationsManagerDashboardInstallationsCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Projects</h1>
        <InstallationsRecap installationsRecap={installationsRecap ?? { totalProjects: 0, hvacBacklog: 0, lightingBacklog: 0, refBacklog: 0, totalProjectsInCloseout: 0, totalProjectsInCloseoutRevenue: 0 }} />
        <InstallationsBySubcontractor
          installationsBySubcontractor={installationsBySubcontractor ?? []}
          height={variables.defaultComponentHeight}
        />
        <CloseoutsBySubcontractor
          closeoutsBySubcontractor={closeoutsBySubcontractor ?? []}
          height={variables.defaultComponentHeight}
        />
      </Flex>
    </Card>
  );
};
